export const utcDateStringFromNumber = (v) =>
    new Date(v).toLocaleDateString(undefined, {
        timeZone: 'UTC',
    });
